import { render } from "./VisitorIdentification.vue?vue&type=template&id=7f8a1e36"
import script from "./VisitorIdentification.vue?vue&type=script&lang=js"
export * from "./VisitorIdentification.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__